import { render, staticRenderFns } from "./StyleguideItem.vue?vue&type=template&id=e2b4a6fc&scoped=true&"
import script from "./StyleguideItem.vue?vue&type=script&lang=ts&"
export * from "./StyleguideItem.vue?vue&type=script&lang=ts&"
import style0 from "./StyleguideItem.vue?vue&type=style&index=0&id=e2b4a6fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b4a6fc",
  null
  
)

export default component.exports